export class BeginnerModeConstants {
}
BeginnerModeConstants.WAIT_MS_TO_FIT_DICE_NUMBER_ANIMATION = 5500;
BeginnerModeConstants.WAIT_MS_BEFORE_AUTO_DICE_ROLL = 2300;
BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION = 500;
